import styled from 'foundations-theming-specialty/utils';
export const StyledLoadingContainer = styled.div.withConfig({
  displayName: "StyledLoadingContainer",
  componentId: "sc-1sjc4ar-0"
})(["position:absolute;top:calc(50% + var(--trellis-space-600,24px));left:50%;transform:translate(-50%,-50%);z-index:3;"]);